import { ONE } from 'config/apis'

const newLicenseFilters = async (clubId = false) => {
  try {
    const req = await fetch(
      clubId
        ? ONE.PRIVATE_CLUB_LIC_NEW.replace('{id}', clubId)
        : ONE.PRIVATE_NEW_FILTERS,
      ONE.HEADERS
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const sendForm = async (formData, clubId = false) => {
  try {
    const req = await fetch(
      clubId
        ? ONE.PRIVATE_CLUB_LIC_NEW.replace('{id}', clubId)
        : ONE.PRIVATE_NEW_FILTERS,
      {
        method: 'POST',
        body: JSON.stringify(formData),
        ...ONE.HEADERS
      }
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const updateForm = async (formData, id) => {
  try {
    const req = await fetch(ONE.PRIVATE_DATA.replace('{id}', id), {
      method: 'POST',
      body: JSON.stringify(formData),
      ...ONE.HEADERS
    })
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const findLicense = async ({ dob, doc }) => {
  try {
    const req = await fetch(
      `${ONE.FIND_LICENSE}?birthDate=${dob}&document=${doc}`,
      ONE.HEADERS
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

export { newLicenseFilters, findLicense, sendForm, updateForm }
